import styles from "../../customer/styles/customerStyles.module.css";

export const StoreTabColorDecisionMaker = (type, total) => {
  if (type === "Orders" || type === "Active" || type === "Products") {
    return (
      <div
        style={{
          background: "rgba(174, 205, 255, 0.5)",
          color: "#1890FF",
        }}
        className={styles.order_tabs}
      >
        {total || 0}
      </div>
    );
  }
  if (type === "Refunds" || type === "requote") {
    return (
      <div
      style={{
        background: "#ecf88e",
        color: "#ffcd03",
      }}
      className={styles.order_tabs}
      >
        {total || 0}
      </div>
    );
  }
  if (type === "pending") {
    return (
      <div
        style={{
          background: "rgba(102, 155, 244, 0.29)",
          color: "rgb(102, 155, 244)",
        }}
        className={styles.order_tabs}
      >
        {total || 0}
      </div>
    );
  }
  if (type === "Fulfilled" || type === "accepted") {
    return (
      <div
        style={{
          background: "rgba(112, 210, 40, 0.31)",
          color: "#6FD226",
        }}
        className={styles.order_tabs}
      >
        {total || 0}
      </div>
    );
  }
  if (type === "Rejected" || type === "failed") {
    return (
      <div
        style={{
          background: "rgba(248, 55, 58, 0.17)",
          color: "#FF1818",
        }}
        className={styles.order_tabs}
      >
        {total || 0}
      </div>
    );
  }
  if (type === "Disputes") {
    return (
      <div
        style={{
          background: "rgba(145, 85, 253, 0.25)",
          color: "#9025FA",
        }}
        className={styles.order_tabs}
      >
        {total || 0}
      </div>
    );
  }
  if (type === "Transactions") {
    return (
      <div
        style={{
          background: "rgba(112, 210, 40, 0.31)",
          color: "#6FD226",
        }}
        className={styles.order_tabs}
      >
        {total || 0}
      </div>
    );
  }

  if (type === "success_deposit") {
    return (
      <div
        style={{
          background: "#DCF0E7",
          color: "#20826D",
        }}
        className={styles.order_tabs}
      >
        {total || 0}
      </div>
    );
  }
  if (type === "deposit") {
    return (
      <div
        style={{
          background: "#EAE8ED",
          color: "#a2a2a2",
        }}
        className={styles.order_tabs}
      >
        {total || 0}
      </div>
    );
  }
};
